import { selectedAssetData } from '@dyl/apiClients/backendApi';
import { useCallback } from 'react';
import useAssetsDownload from './useAssetsDownload';

export default function useExport() {
    const download = useAssetsDownload();

    return useCallback(
        /**
         * @param {string[]} selectedIds
         */
        async function exportAssets(selectedIds, module) {
            let assetsToExport = [];

            if (selectedIds.length > 0) {
                const result = await selectedAssetData(selectedIds, module);
                assetsToExport = Array.isArray(result) ? result : Object.values(result);
            }
            const toExport = assetsToExport;

            await download(toExport);

        }, [download]
    );
}